import Head from 'next/head';

import defaultMetaInfo from '@/constants/defaultMetaInfo';
import { useAppSelector } from '@/redux/hooks';

export default function CompanyMetadata() {
  const companyCustomization = useAppSelector((state) => state.auth.companyAccount?.customization_uid);

  const metaInfo = {
    head_title: companyCustomization?.head_title || defaultMetaInfo.metaTitle,
    head_description: companyCustomization?.head_description || defaultMetaInfo.metaDescription,
    favicon: companyCustomization?.favicon || defaultMetaInfo.faviconURL,
  };

  return (
    <Head>
      <title>{metaInfo.head_title}</title>
      <meta key="metaDescription" content={metaInfo.head_description} name="description" />
      <meta key="metaOgTitle" content={metaInfo.head_title} property="og:title" />
      <meta key="metaOgDescription" content={metaInfo.head_description} property="og:description" />
      <meta key="metaOgImage" content={metaInfo.favicon} property="og:image" />
      <link key="linkIcon" href={metaInfo.favicon} rel="icon" />
      <link key="linkAppleTouchIcon" href={metaInfo.favicon} rel="apple-touch-icon" sizes="180x180" />
    </Head>
  );
}
